import React, { useMemo } from 'react'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { AiOutlineCheck } from "react-icons/ai";
import styles from '../styles.module.scss'
import Button from '../../../components/Button';
import { createComissionApprove, deleteComissionApprove, toggleExpertAbsentStatus } from '../../../actions/common';
import { createNotification } from '../../../components/Notifications/Notifications';
import moment from 'moment';
import Switch from '../../../components/Switch'




const CAN_CHANGE_ABSENT_POSITIONS = ['председатель комиссии', 'заместитель председателя комиссии', 'секретарь комиссии']


export default function ExpertComissionBlock ({ requestId, commId }) {
  
  const { user_id } = useSelector(state => state.auth)
  const { list, values } = useSelector(state => state.common.comission)
  const dispatch = useDispatch()

  const approvedUsers = values?.map(_ => _.mid) || []
  const alreadyApproved = approvedUsers.includes(user_id)

  const includeExpert = list?.map(_ => _.MID).includes(user_id)

  // const canChangeAbsentStatus = useMemo(() => list?.filter(i => CAN_CHANGE_ABSENT_POSITIONS.includes(i.position.toLowerCase())).map(i => i.MID).includes(user_id), [])

  const toggleExpertStatus = (mid, absent) => () => {
    const body = { mid, absent: !absent }
    dispatch(toggleExpertAbsentStatus(commId, body, true))
  }

  const renderRow = (expert, index) => {
    const {MID, LastName, FirstName, Patronymic, absent} = expert
    const value = values?.find(({mid}) => mid === MID)
    const fio = `${LastName} ${FirstName} ${Patronymic}`
    const createdAt = moment(value?.created_at).format('DD.MM.YYYY HH:mm')
    const switchHint = absent ? 'Отсутствует по уважительной причине' : 'Эксперт присутствует'
    return (
      <tr>
        <td>{fio}</td>
        <td>
          <Switch
            hint={switchHint}
            checked={!absent}
            // disabled={!canChangeAbsentStatus}
            onClick={toggleExpertStatus(MID, absent)}
          />
        </td>
        <td title={value && 'Удалить подпись'} onClick={value && handleDelete(value)}>
          {value && <AiOutlineCheck size={22} color='#10d310' />}
          {value && <span className={styles.createdAt}>({createdAt})</span>}
        </td>
      </tr>
    )
  }

  const handleApprove = () => {
    const param = { status: 1, is_expert: true}
    dispatch(createComissionApprove(requestId, param))
  }

  const handleDelete = (value) => () => {
    if (value.mid !== user_id) return createNotification('error', 'Нельзя удалить чужую подпись');
    dispatch(deleteComissionApprove(value.id, requestId, true))
  }

  return (
    <div className={styles.comissionBlock}>
     
     <Table id='comissionTable'>
        <thead>
          <tr>
            <th>ФИО</th>
            <th/>
            <th>Подпись</th>
          </tr>
        </thead>
        <tbody>
          {list?.map(renderRow)}
        </tbody>
      </Table>

      <Button
        disabled={!list?.length || !includeExpert || alreadyApproved}
        onClick={handleApprove}
        label='Проверено'
      />

    </div>
  )
}